/* istanbul ignore file */
// eslint-disable-next-line no-underscore-dangle
export default window.__WTR_COMMON__.config;
